/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { Checkbox } from '@mui/material';
import { ShipmentStatus } from '@constants';
import { useNavigate } from 'react-router-dom';
import { SplitLine, Tag } from '../common';
import { Merchandise } from '../merchandise';
import classes from './index.module.css';
import { RemarkPanel } from './remark-panel';
import { WrongInfo } from '../wongInfo';

const HAS_CLAIME_TEXT = 'This item already has a reported issue.';

export const CheckBoxItem = ({
  item,
  handleChange,
  index,
  packageIndex,
  disabled = false,
  selectedItems = [], handleEdit, reasonList = [],
}) => {
  const navigate = useNavigate();
  const {
    reason, claimId, comment, attachments,
  } = item;

  const handleItemClick = (item) => {
    navigate(`/17track/feedback?claimId=${item.claimId}`);
  };

  return (
    <div key={`${item.lineItemId}_${packageIndex}_${index}`}>
      {index === 0 ? null : <SplitLine />}
      <section id="responsive_line_item" className={classes.check_box_item}>
        <Checkbox
          id="responsive_line_item_checkbox"
          color="input"
          onChange={(e) => handleChange(e, packageIndex, index, item)}
          disabled={disabled}
          value={`${item.lineItemId}_${packageIndex}_${index}`}
          checked={selectedItems?.includes(`${item.lineItemId}_${packageIndex}_${index}`)}
        />
        <Merchandise item={item} className={classes.check_merchandise} />
      </section>
      {/* 是否已经申请过 */}
      {claimId
        ? (
          <RemarkPanel
            title={HAS_CLAIME_TEXT}
            btnText="View issue &gt; "
            isShow={false}
            onClick={() => handleItemClick(item)}
          />
        )

        : null}
      {/* 未申请且选择了原因 */}
      {(!claimId && reason) ? (
        <RemarkPanel
          title={reasonList.find((v) => v.value === reason)?.label}
          btnText="Edit"
          files={attachments.map((item) => item.originalFileName)}
          additional={comment}
          onClick={() => handleEdit(item, packageIndex, index)}
        />
      ) : null}
      <div style={{ height: '1px' }}></div>
    </div>
  );
};

export const PackageCheckboxGroup = ({
  packageItem,
  packageIndex,
  onChange,
  selectedItems,
  handleItemEdit,
  reasonList,
  undeliveredAbled,
}) => {
  if (!packageItem) {
    return null;
  }
  const { items, status, fulfillmentName } = packageItem;
  const isDelivered = status === ShipmentStatus.Delivered;
  return (
    <>
      {packageIndex === 0 ? null : <SplitLine />}
      {fulfillmentName ? (
        <section className={classes.radio_line}>
          <span className={classes.order_name}>
            <span className={classes.order_name_title}>Order</span>
            {fulfillmentName}
          </span>
          <Tag
            color={isDelivered ? '#AEE9D1' : '#E4E5E7'}
            text={isDelivered ? 'Delivered' : 'Undelivered'}
          />
          {
            !isDelivered ? (
              <WrongInfo name={fulfillmentName} status={status} />
            ) : null
          }
        </section>
      ) : null}
      {items.map((item, index) => (
        <CheckBoxItem
          key={item.lineItemId + index}
          item={item}
          handleChange={onChange}
          index={index}
          selectedItems={selectedItems}
          packageIndex={packageIndex}
          disabled={!!item.claimId || (!undeliveredAbled && !isDelivered)}
          handleEdit={handleItemEdit}
          reasonList={reasonList}
        />
      ))}
    </>
  );
};
